// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1Ug7i","header":"PatientBlock_header__DgdRb","label":"PatientBlock_label__2YOG8","option":"PatientBlock_option__2P-6c"};